import * as yup from "yup";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

var documentSchema = yup.object({
  name: yup.string().required(),
  filename: yup.string().required(),
  doc_type: yup.string().required(),
  expiration_date: yup.string().nullable(),
  description: yup.string().nullable(),
});

var requestSchema = yup.object({
  patientId: yup.number().required(),
  documents: yup.array().of(documentSchema).required(),
});

export function usePatientDocumentCreateMutation(options = {}) {
  var queryClient = useQueryClient();

  return useMutation(
    async (dto) => {
      const req = requestSchema.validateSync(dto, {
        strict: true,
      });
      return http.post(HTTP_ENDPOINTS.patientDocuments.create(), {
        patient_id: req.patientId,
        documents: req.documents,
      });
    },
    {
      ...options,
      onSuccess: (...args) => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.patientDocuments.all],
        });
        options?.onSuccess?.(...args);
      },
    },
  );
}
